import { Dialog, DialogType, DialogFooter, PrimaryButton, DefaultButton, IDialogProps } from "@fluentui/react";
import type { IDialogContentProps } from '../../../node_modules/@fluentui/react/lib/components/Dialog/DialogContent.types';

interface MessageBoxProps extends IDialogProps {
    hidden: boolean;
    dialogContentProps: IDialogContentProps;
    onConfirm: () => void;
    onDismiss: () => void;
    showCancelButton: boolean;
  }

export const MessageDialog: React.FC<MessageBoxProps> = ({ hidden, dialogContentProps, onConfirm, onDismiss, showCancelButton }) => {
    return (
      <div style={{position: "absolute"}}>
        <Dialog
          hidden={hidden}
          onDismiss={onDismiss}
          dialogContentProps={dialogContentProps}
          modalProps={{
            isBlocking: false,
            styles: { main: { maxWidth: 450, whiteSpace: 'pre-wrap' } },
          }}
        >
          <DialogFooter>
              <PrimaryButton onClick={onConfirm} text="OK" />
              {showCancelButton && <DefaultButton onClick={onDismiss} text="Cancel" />}
          </DialogFooter>
        </Dialog>
      </div>
    );
  };